__turbopack_context__.v({
  "className": "inter_ab573607-module__U70w2a__className",
});
